<template>
  <div id="ErrorPage" class="animated fadeIn d-flex flex-row aic jcc vh-100">
    <b-card class="wauto border0">
      <b-row class="errIcon">
        <b-col class="col-12">
          <div class="d-flx jcc">
            <i class="fa fa-exclamation border0"></i>
          </div>
        </b-col>
      </b-row>
      <b-row class="errHeader">
        <b-col class="col-12">
          <h1>페이지를 찾을 수 없습니다.</h1>
        </b-col>
      </b-row>
      <b-row class="errContents">
        <b-col class="col-12">
          방문하시려는 페이지의 주소가 잘못 입력되었거나,<br />
          페이지의 주소가 변경 혹은 삭제되어 요청하신 페이지를 찾을 수
          없습니다.<br />
          입력하신 주소가 정확한지 다시 한번 확인해 주시기 바랍니다.<br />
        </b-col>
      </b-row>
      <div class="btnGrp">
        <div class="jcc">
          <b-button class="" @click="previousPage">이전 페이지로</b-button>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters([]),
  },
  created() {},
  methods: {
    previousPage() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
#ErrorPage div.card-body {
  background-color: #272c30;
}
#ErrorPage div.card-body .row.errIcon div i {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  font-size: 35px;
  color: #e2e2e2;
  margin-bottom: 10px;
  background-color: #2e3339;
  border-radius: 10px;
}
#ErrorPage div.card-body .row.errHeader h1 {
  text-align: center;
  font-size: 40px;
  color: #e2e2e2;
  margin-bottom: 20px;
}
#ErrorPage div.card-body .row.errContents {
  font-size: 18px;
  color: #e2e2e2;
}
#ErrorPage div.card-body .btnGrp {
  border-top: 1px solid #393d42;
  margin: 15px 0 0;
}
#ErrorPage div.card-body .btnGrp button {
  color: #e2e2e2;
  background: #2e3339;
  border: 1px solid #d5d6d7;
}
</style>



// WEBPACK FOOTER //
// src/components/error/error404.vue